export const environment = {
  production: true,
  baseUrl: 'https://safroo-prod-api.azurewebsites.net/api',
  debugMode: false,
}
